var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "margin-top-3x" }, [
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
        ])
      : _c("div", { staticClass: "row margin-top-4x" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              { staticClass: "margin-top-2x" },
              [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-striped table-sm" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.esim_reservations.data, function(item) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  item.created_at,
                                  "MM/DD/YYYY hh:mm A"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.reservation_number))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.iccid))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.email))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(item.destination.name) +
                                " (" +
                                _vm._s(item.destination.type) +
                                ")"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  item.start_date,
                                  "MM/DD/YYYY"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  item.end_date,
                                  "MM/DD/YYYY"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.data_limit_in_gb))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.base_price))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.total_price))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.markup_amount))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.channel_commission))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.reslab_commission))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.channel_markup_type))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.channel_markup_value))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.reslab_fee_value))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.currency))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.reference_number))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(item.manual_activation_code))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.min_days))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.max_days))])
                        ])
                      }),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.esim_reservations && _vm.esim_reservations.last_page
                  ? _c("pagination", {
                      attrs: {
                        "pages-number": _vm.esim_reservations.last_page
                      },
                      on: {
                        pageChanged: function(page) {
                          return _vm.loadEsimReservations(page)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Created at")]),
        _vm._v(" "),
        _c("th", [_vm._v("Res #")]),
        _vm._v(" "),
        _c("th", [_vm._v("iccid")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Destination")]),
        _vm._v(" "),
        _c("th", [_vm._v("StartDate")]),
        _vm._v(" "),
        _c("th", [_vm._v("End Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data limit in GB")]),
        _vm._v(" "),
        _c("th", [_vm._v("Base price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Markup amount")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab fee (%) ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Currency")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reference number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Manual activation code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Min Days")]),
        _vm._v(" "),
        _c("th", [_vm._v("Max Days")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8915c1b0", { render: render, staticRenderFns: staticRenderFns })
  }
}